import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import * as types from '../actions/types';
import runs from './runsReducer';
import login from './loginReducer';
import run from './runReducer';
import auth from './authReducer';
import courses from './coursesReducer';
import course from './courseReducer';
import conflicts from './conflictsReducer';
import requirements from './requirementsReducer';
import profile from './profileReducer';
import crosslist from './crosslistReducer';
import students from './studentsReducer';
import student from './studentReducer';
import groups from './groupsReducer';
import group from './groupReducer';
import school from './schoolReducer';
import assignments from './assignmentsReducer';
import waitlist from './waitlistReducer';
import general from './general'

const rootReducer = combineReducers({
  form: formReducer.plugin({
    administratorsForm: (state, action) => {
      // <------ 'administrtorsForm' is name of form given to reduxForm()
      switch (action.type) {
        case types.GET_DEANS_SUCCESS:
          return undefined; // <--- blow away form data
        default:
          return state;
      }
    },
    adminForm: (state, action) => {
      // <------ 'adminForm' is name of form given to reduxForm()
      switch (action.type) {
        case types.CHANGE_PASSWORD_SUCCESS:
          return undefined; // <--- blow away form data
        default:
          return state;
      }
    },
    StudentForm: (state, action) => {
      // <------ 'adminForm' is name of form given to reduxForm()
      switch (action.type) {
        case types.CHANGE_PASSWORD_SUCCESS:
          return undefined; // <--- blow away form data
        default:
          return state;
      }
    }
  }),
  runs,
  run,
  login,
  auth,
  courses,
  course,
  conflicts,
  requirements,
  profile,
  crosslist,
  students,
  student,
  groups,
  group,
  school,
  assignments,
  waitlist,
  general
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js